import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia } from '@pkg/primitives';

import { type FieldTextProps } from '../FieldText';
import { tokens as fieldTextTokens } from '../FieldText/FieldText.tokens';

import { clearActionTransition, ClearActionVariant, clearActionVariants } from './FieldSearch.motion';

import { tokens } from './FieldSearch.tokens';

interface AttachedProps {
    $theme?: FieldTextProps['theme'];
}

export const SearchIconWrapper = styled.div<AttachedProps>`
    ${styledMedia.iconWrapper};
    margin-left: ${fieldTextTokens.padding.small}px;
    width: ${tokens.search.size}px;
    height: ${tokens.search.size}px;
    color: rgb(255, 255, 255, 0.4);

    ${({ $theme }) =>
        $theme === 'light' &&
        css`
            color: rgb(0, 0, 0, 0.4);
        `};
`;

export const ClearActionWrapper = styled(motion.div).attrs({
    variants: clearActionVariants,
    initial: ClearActionVariant.Hidden,
    animate: ClearActionVariant.Show,
    exit: ClearActionVariant.Hidden,
    transition: clearActionTransition,
})<AttachedProps>`
    --icon-color: rgb(255, 255, 255, 1);

    &:last-child {
        margin-right: ${fieldTextTokens.padding.small}px;
    }

    ${({ $theme }) =>
        $theme === 'light' &&
        css`
            --icon-color: rgb(0, 0, 0, 0.8);
        `};
`;

export const ClearAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    width: ${tokens.clear.size}px;
    height: ${tokens.clear.size}px;

    &:hover {
        background-color: rgb(255, 255, 255, 0.2);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.1);
    }
`;

export const ClearIconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.clear.icon}px;
    height: ${tokens.clear.icon}px;
    color: var(--icon-color);
`;
